export const noteFields = {
    ID: 'id',
    NOTE_TITLE: 'note_title',
    NOTE_DATE: 'note_date',
    NOTE: 'note',
    NOTE_AGENT_ID: 'agent_id',
}